import { Divider, Skeleton as MuiSkeleton, Paper, type SkeletonProps, Stack, styled } from '@mui/material'

const Skeleton = (props: SkeletonProps) => <MuiSkeleton {...props} sx={{ transform: 'unset' }} />

export const RelationSkeleton = () => (
  <Stack
    sx={{
      flex: 1,
      gap: 2,
      minHeight: 0,
      overflow: 'hidden',
    }}
  >
    <Stack
      sx={{
        alignItems: 'baseline',
      }}
    >
      <Skeleton width={40} height={40} />
    </Stack>
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Skeleton width="40%" height={40} />
      <Skeleton width={120} height={40} />
    </Stack>
    <Container
      sx={{
        gap: 2,
      }}
    >
      <Skeleton width="100%" height={56} />
      <RelativeListContainer>
        <Stack
          sx={{
            gap: 2,
          }}
        >
          <Skeleton width={120} height={24} />
          <Skeleton width="100%" height={91.2} />
          <Skeleton width="100%" height={91.2} />
        </Stack>
      </RelativeListContainer>
      <Divider />
      <Skeleton width={160} height={32} />
      <Stack
        direction="row"
        sx={{
          gap: 2,
          alignItems: 'center',
        }}
      >
        <Skeleton width="100%" height={56} sx={{ transform: 'unset', flex: 1 }} />
        <Skeleton width="100%" height={56} sx={{ transform: 'unset', flex: 1 }} />
        <Skeleton width={100} height={40} />
      </Stack>
      <RelativeListContainer>
        <Stack
          sx={{
            gap: 2,
          }}
        >
          <Skeleton width={100} height={24} />
          <Skeleton width="100%" height={56} />
          <Skeleton width="100%" height={56} />
        </Stack>
      </RelativeListContainer>
    </Container>
  </Stack>
)

const Container = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
}))

const RelativeListContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
}))
